import { useQueryClient } from '@tanstack/react-query';

import { UnavailableState } from '@/components/UnavailableState/UnavailableState';
import { ConfigurationQueryKey } from '@/constants/QueryKeys';
import { useAmelioTranslations } from '@/hooks';

/**
 * What a gated route shows once the configuration request has failed, rather than telling the
 * reader the feature is not for them. The retry asks the one query the flags come from, the same
 * one `App` writes them from.
 */
export const FeatureFlagsUnavailableState = () => {
    const { t } = useAmelioTranslations();
    const queryClient = useQueryClient();

    return (
        <UnavailableState
            title={t('errors.configurationUnavailableTitle')}
            message={t('errors.configurationUnavailableMessage')}
            onRetry={() => {
                queryClient.refetchQueries({ queryKey: [ConfigurationQueryKey.CONFIGURATION] });
            }}
        />
    );
};
